module.exports = __webpack_public_path__ + "img/camera2.0dbe2875.svg";